module.exports = __webpack_public_path__ + "img/20240710110250421u1g.e6f9bbe1.jpg";